import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { getMobHeaderClassAPI } from '../../shared/constants/end-point-constants';
import { ApiConfigService } from '../api-config/api-config.service';
import { HttpHandlerService } from '../http-handler/http-handler.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  showCartIcon$ = new BehaviorSubject<boolean>(false);
  showHomeIcon$ = new BehaviorSubject<boolean>(false);
  applyVDClass$ = new BehaviorSubject<boolean>(true);
  allowHeaderNavigation$ = new BehaviorSubject<boolean>(true);
  clearSessionBeforeNavigation$ = new BehaviorSubject<boolean>(false);
  cartItemCount$ = new BehaviorSubject<number>(0);
  loggedInUserFullName$ = new BehaviorSubject<string>('');
  shopProfilePictureUrl$ = new BehaviorSubject<string>('');
  hideLoginIcon$ = new BehaviorSubject<boolean>(false); // used to hide login icon from within the application
  hideUserInfo$ = new BehaviorSubject<boolean>(false); // used to hide logged-in user info in header from within the application
  isUserLoggedIn$ = new BehaviorSubject<boolean>(false); // denotes both shopowner/customer logged in

  constructor(
    private apiConfigService: ApiConfigService,
    private httpHandlerService: HttpHandlerService,
  ) { }

  /**
   *
   *
   * @description to get the header class
   * from page-mob-header-class.json file
   * @returns
   * @memberof HeaderService
   */
  getMobHeaderClasses(): Observable<any> {
    return new Observable(observer => {
      const api = this.apiConfigService.getAPIPath(getMobHeaderClassAPI);
      this.httpHandlerService.callServerGET(api).subscribe(
        (response) => {
          observer.next(response);
          observer.complete();
        },
        (error) => {
          observer.error(error);
          observer.complete();
        }
      );
    });
  }
}
